import styled, { css } from "styled-components";
import { background, inactiveItens, shadowColor } from "../../../theme";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    border-radius: 0.3125rem;
    outline: 0;
    z-index: 999;
    min-width:100vw;
    max-width:100vw;
    min-height: calc(100 * var(--vh));
    max-height: calc(100 * var(--vh));
    box-shadow: 0.125rem 0.125rem 0.5rem ${props => shadowColor['light']};
    @media (min-width: 550px) {
        min-width:80vw;
        max-width:80vw;
        min-height: calc(90 * var(--vh));
        max-height: calc(90 * var(--vh));
    }
    background: ${background['light']};
    color: ${inactiveItens['light']};
`

export const Paragraph = styled.div`
    margin-bottom: 19px;
    font-size: 14px;
    padding: 0 1.5rem;
`

export const Title = styled.div`
    margin-bottom: 19px;
    font-size: 14px;
    padding: 0 1.5rem;
    font-weight: 600;
`